
import React, { useState, useEffect, useRef } from 'react';
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import printJS from 'print-js'; // If using npm
import moment from 'moment';
import AlertMessage from '../../AlertMessage';
import Watermark from '../../assets/images/Watermark.png'
import 'firebase/compat/database';

function Leavdoc({ submitted, formData, isStudentActive }) {
  const [schoolData, setSchoolData] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const language = localStorage.getItem('language') || 'English';
  const [logoURL, setLogoURL] = useState('');
  const [logoURL2, setLogoURL2] = useState('');
  const [loading, setLoading] = useState(true);
  // const [walletPoints, setWalletPoints] = useState(0);
  const udiseNumber = localStorage.getItem("udiseNumber")
  const [documentNumber, setDocumentNumber] = useState(null);

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [birthPlaceTop, setBirthPlaceTop] = useState('6.2in'); // State for top position
  const [sinceWhenTop, setsinceWhenTop] = useState('8.3in'); // State for top position
  const sinceWhenRef = useRef(null);
  const birthPlaceRef = useRef(null); // Ref for the birth place text

  const [isFreeTrial, setIsFreeTrial] = useState(false); // Added state for free trial status
  const [duplicate, setDuplicate] = useState(false);
  const [currentThemeIndex, setCurrentThemeIndex] = useState(0);
  const [isDefaultTheme, setIsDefaultTheme] = useState(false);

  const [day, month, year] = formData.printdate ? formData.printdate.split('-') : ['', '', ''];



  // Fetch pack activation status from Firebase
  useEffect(() => {
    if (udiseNumber) {
      const dbRef = firebase.database().ref(`/Admin/${udiseNumber}`);
      dbRef.once('value').then((snapshot) => {
        const data = snapshot.val();
        if (data && data.packActivated === "freeTrial") {
          setIsFreeTrial(true);
        } else {
          setIsFreeTrial(false);
        }
      }).catch(error => {
        console.error("Error fetching pack activation status:", error);
      });
    }
  }, [udiseNumber]);

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);

      request.onerror = (event) => {
        console.error('Database error:', event.target.error);
        reject('Error opening IndexedDB');
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      // If the database doesn't exist yet, create it
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };


  const [isPrincipal, setIsPrincipal] = useState(true);
  const [isDean, setIsDean] = useState(true);
  const [isHeadmaster, setIsHeadmaster] = useState(false);

  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['defaultSettings'], 'readonly');
        const objectStore = transaction.objectStore('defaultSettings');
        const request = objectStore.get('defaultSettings');

        request.onsuccess = (event) => {
          const data = event.target.result;

          if (data) {
            console.log("data", data);

            setIsDean(data.isDean)
            setIsPrincipal(data.isPrincipal)
            setIsHeadmaster(data.isHeadmaster || false) // Add this line
          } else {
            console.warn("No default settings found for the key 'defaultSettings'.");
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching default year:', error);
      }
    }
    fetchDefaultSettings();
  }, [udiseNumber]);



  const renderContent = () => {
    if (!schoolData || !formData) return null;


    return (
      <>
        <div
          style={{
            marginBottom: '300px ',
            position: 'absolute',
            top: '0.80in',
            bottom: '0in',
            right: '0.35in', // Aligns the right edge of the box with the right edge of the page
            width: '7.6in',  // 8.5in - 0.4in (0.2in on each side)
            height: '11in', // 11in - 0.4in (0.2in on each side)
            fontFamily: "'NotoSansDevanagari', sans-serif",
            border: '0.03in solid black',
            boxSizing: 'border-box',
            padding: '0.2in', // Add padding to create margin inside the border
            // Responsive adjustments
            '@media (max-width: 1200px)': {  // For screens narrower than 1200px
              right: '0in',
              width: '8in',
              height: '11in',
            },
            '@media (max-width: 992px)': {  // For screens narrower than 992px
              right: '0in',
              width: '8.5in',
              height: '11.5in',
            },
            '@media (max-width: 768px)': {  // For screens narrower than 768px
              top: '0.2in',
              right: '0in',
              width: '100%',
              height: 'auto',
              padding: '0.1in',
            },
          }}
        >

          <div
            style={{
              position: 'absolute',
              top: '0.1in',
              left: '0in',
              right: '0in',
              textAlign: 'center',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {schoolData.sansthaName && (
                <div
                  style={{
                    fontSize: '10.4px',
                    fontWeight: 'bold',
                    wordWrap: 'break-word',
                    textAlign: 'center',
                    marginBottom: '-10px', // add this
                  }}
                >
                  {schoolData.sansthaName}
                </div>
              )}
              <div
                style={{
                  fontSize: '19px',
                  fontWeight: 'bold',
                  wordWrap: 'break-word',
                  textAlign: 'center',
                  marginTop: schoolData.sansthaName ? '10px' : '0px', lineHeight: '1.1'
                }}
              >
                {schoolData.schoolName}
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '0.35in',
                  left: '15%',
                  right: '15%',
                  boxSizing: 'border-box',
                  padding: '0',
                }}
              >
                <div
                  style={{
                    margin: '0 auto',
                    width: '100%',
                    maxWidth: 'calc(100% - 0.6in)',
                    boxSizing: 'border-box',
                    textAlign: 'center',
                  }}
                >
                  <p style={{

                    fontSize: '18px',
                    fontWeight: 'bold',
                    wordWrap: 'break-word',
                    display: 'inline-block',
                  }}>

                  </p>
                  <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
                    {language === 'English' ? (
                      <>
                        <strong>Taluka : </strong>{schoolData.taluka},<strong> District :</strong> {schoolData.jilha},<strong>Phone No :</strong> {schoolData.mobileNumber}
                      </>
                    ) : (
                      <>
                        <strong> तालुका : </strong>{schoolData.taluka}, <strong>जिल्हा :</strong> {schoolData.jilha},<strong>दूरध्वनी क्र :</strong> {schoolData.mobileNumber}
                      </>
                    )}
                  </p>

                  <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
                    {language === 'English' ? (
                      <>
                        <strong>UDISE No :</strong> {schoolData.udiseNumber}, <strong>Board :</strong> {schoolData.boardName}
                      </>
                    ) : (
                      <>
                        <strong>UDISE क्र :</strong> {schoolData.udiseNumber}, <strong>बोर्ड :</strong> {schoolData.boardName}
                      </>
                    )}
                  </p>

                  <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
                    {language === 'English' ? (
                      <>
                        <strong>Email :</strong> {schoolData.email}
                      </>
                    ) : (
                      <>
                        <strong>ई-मेल :</strong> {schoolData.email}
                      </>
                    )}
                  </p>

                  <div style={{ textAlign: 'left', whiteSpace: 'nowrap', fontSize: '13px', lineHeight: '1.4' }}>
                    <p style={{ margin: '2px 0', padding: '0' }}>
                      {language === 'English' ? (
                        <>
                          <strong>Index No :</strong> {schoolData.indexNumber}
                          <br />
                          <strong>Recognition No :</strong> {schoolData.manyataKramank}
                        </>
                      ) : (
                        <>
                          <strong>अनुक्रमांक क्र :</strong> {schoolData.indexNumber}
                          <br />
                          <strong>मान्यता क्र :</strong> {schoolData.manyataKramank}
                        </>
                      )}
                    </p>
                  </div>


                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: '1.4in',
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
              }}
            >
              {logoURL && (
                <img
                  src={logoURL}
                  alt="School Logo"
                  style={{
                    position: 'absolute',
                    top: '0.55in',
                    left: '0.28in', width: '110px', height: '110px', marginRight: '10px'
                  }}
                />
              )}

            </div>
            <div
              style={{
                marginTop: '1.3in',
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'center',
              }}
            >
              {logoURL2 && (
                <img
                  src={logoURL2}
                  alt=""
                  style={{
                    position: 'absolute',
                    top: '0.52in',
                    right: '0.2in', width: '110px', height: '110px', marginRight: '10px'
                  }}
                />
              )}

            </div>

          </div>

          <div
            style={{
              position: 'absolute',
              top: '1.73in',
              left: '2.6in',
              width: '2.55in',
              height: '0.32in',
              textAlign: 'center',
              border: '0.025in solid black',
              margin: '10px 0',
              backgroundColor: 'black', // add this
              color: 'white', // add this
              borderRadius: '0.1in', // add this
              printColorAdjust: 'exact',
              WebkitPrintColorAdjust: 'exact',
            }}
          >
            <h3 style={{ color: 'white', fontSize: '17px', margin: '5px 0', fontWeight: 'bolder' }}>
              <p>
                {language === "English"
                  ? "School Leaving Certificate"
                  : "शाळा सोडल्याचे प्रमाणपत्र"}
              </p>
            </h3>
          </div>
          {showDuplicateText && (
            <p style={{ position: 'absolute', top: '1.85in', left: '1.5in', fontSize: '18px', color: 'red' }}>
              {duplicate && language === "English" ? (
                <>
                  <>Duplicate</>
                </>
              ) : duplicate && language !== "English" ? (
                <>
                  <strong>दुबारप्रत</strong>
                </>
              ) : (
                <></>
              )}
            </p>
          )}

          <p style={{ position: 'absolute', top: '1.75in', left: '5.84in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Book No :</strong> {formData.bookno}
              </>
            ) : (
              <>
                <strong>बूक क्र :</strong> {formData.bookno}
              </>
            )}
          </p>


          <p style={{ position: 'absolute', top: '1.95in', left: '5.84in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Medium :</strong> {schoolData.madhyam}
              </>
            ) : (
              <>
                <strong>माध्यम :</strong> {schoolData.madhyam}
              </>
            )}
          </p>




          {isFreeTrial && (
            <img
              src={Watermark}
              alt="Free Trial Watermark"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(-10deg)",
                width: "80%",
                opacity: 0.2,
                pointerEvents: "none",
                zIndex: 0
              }}
            />
          )}



          <p style={{ position: 'absolute', top: '1.9in', left: '0.25in', fontSize: '13px' }}>
            {documentNumber || 'Not Generated'}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.7in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.2in', left: '0in', right: '0in' }}></div>
          <div style={{ borderLeft: '0.02in solid black', position: 'absolute', top: '3.5in', left: '3.44in', height: '6.05in', }}></div>



          <p style={{ position: 'absolute', top: '2.3in', left: '0.8in', fontSize: '12px', }}>
            {language === "English"
              ? "  No changes are to be made in any entries, only issuance of leaving certificate by the authorized officer."
              : "या दाखल्यात शाळेच्या मुख्याध्यापकाशिवाय कोणत्याही प्रकारचा फेरबदल करू नये .तसे केल्यास तो गंभीर प्रकारचा गुन्हा"}</p>

          <p style={{ position: 'absolute', top: '2.5in', left: '2.6in', fontSize: '12px' }}>
            {language === "English"
              ? "  Teaching certificate with education will be taken."
              : "समजण्यात येऊन अपराधी शिक्षेस पात्र होईल."}</p>

          <p style={{ position: 'absolute', top: '2.8in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>GR. No. :</strong> {formData.registerno}
              </>
            ) : (
              <>
                <strong>रजिस्टर क्र :</strong> {formData.registerno}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.05in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>SARAL ID :</strong> {formData.studentId}
              </>
            ) : (
              <>
                <strong>सरल आयडी :</strong> {formData.studentId}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.3in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>APAAR ID :</strong> {formData.aparId}
              </>
            ) : (
              <>
                <strong>अपार आयडी :</strong> {formData.aparId}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '2.8in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission date :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            ) : (
              <>
                <strong>प्रवेशाची तारीख :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            )}
          </p>
          <p style={{ position: 'absolute', top: '3.05in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission Class :</strong> {formData.admissionClass}
              </>
            ) : (
              <>
                <strong>प्रवेश वर्ग :</strong> {formData.admissionClass}
              </>
            )}
          </p>
          <p style={{ position: 'absolute', top: '3.3in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Mother Tounge :</strong> {formData.motherTounge}
              </>
            ) : (
              <>
                <strong>मातृभाषा :</strong> {formData.motherTounge}
              </>
            )}
          </p>








          <p style={{ position: 'absolute', top: '2.8in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Educational Year :</strong> {formData.educationalYear}
              </>
            ) : (
              <>
                <strong>शैक्षणिक वर्ष :</strong> {formData.educationalYear}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.05in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Aadhar Card No :</strong> {formData.stdAdharNo}
              </>
            ) : (
              <>
                <strong>विद्यार्थी आधार क्र :</strong> {formData.stdAdharNo}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.3in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>PEN No :</strong> {formData.panId}
              </>
            ) : (
              <>
                <strong>PEN क्र :</strong> {formData.panId}
              </>
            )}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.5in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '3.6in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Full Name of Student"
              : "विद्यार्थ्याचे संपूर्ण नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '3.6in', left: '3.5in' }}>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.9in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4in', left: '0.4in' }}>
            <b> {language === "English"
              ? "  Mother's Name"
              : "आईचे नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4in', left: '3.5in' }}>
            {formData.stdMother}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.3in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.4in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Religion"
              : "धर्म "}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.4in', left: '3.5in' }}>
            {formData.religion}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.8in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Caste- Sub Caste"
              : "जात-पोटजात"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.8in', left: '3.5in' }}>
            {formData.caste && formData.subCaste
              ? `${formData.caste} - ${formData.subCaste}`
              : formData.caste || formData.subCaste}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.1in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.2in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Nationality  "
              : "राष्ट्रीयत्व"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.2in', left: '3.5in' }}>
            {formData.nationality}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.5in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.55in', left: '0.4in' }}>
            <b> {language === "English"
              ? " Date of Birth "
              : "इ. सनप्रमाणे जन्म दिनांक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.8in', left: '0.4in' }}>
            <b>{language === "English"
              ? "(Numerical and in words) "
              : "(अंकी व अक्षरी)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.55in', left: '3.5in' }}>
            {moment(formData.dob).format('DD-MM-YYYY')} </p>

          <p style={{ position: 'absolute', top: '5.8in', left: '3.5in', fontSize: '0.93em' }}>
            {formData.dobInWords}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.1in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '6.2in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Place of Birth  "
              : "जन्म स्थळ"}</b>
          </p>
          <p
            ref={birthPlaceRef}
            style={{
              position: 'absolute',
              top: birthPlaceTop,
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.birthPlace}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.5in', left: '0in', right: '0in' }}></div>


          <p style={{ position: 'absolute', top: '6.58in', left: '0.4in', fontSize: '0.99em', lineHeight: '1.2' }}>
            <b> {language === "English"
              ? "Previous School Name "
              : "या शाळेत येण्यापूर्वी शिकत असलेली शाळा "}</b> <br />
            <b> {language === "English"
              ? "and Class "
              : "व इयत्ता"}</b>


          </p>
          {/* <p style={{ position: 'absolute', top: '6.74in', left: '0.4in', fontSize:'0.99em' }}>
        <b> {language === "English"
                ? "and Class"
                : "व इय्यता"}</b>
        </p> */}
          <p style={{ position: 'absolute', top: '6.56in', left: '3.5in', fontSize: '0.8em' }}>
            {formData.prevSchool && formData.prevClass
              ? `${formData.prevSchool} - ${formData.prevClass}`
              : formData.prevSchool || formData.prevClass}


          </p>
          {/* <p style={{ position: 'absolute', top: '6.74in', left: '3.5in', fontSize:'0.8em'}}>
          {formData.admissionClass}
        </p>  */}
          {/**/}


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.1in', left: '0.4in' }}>
            <b> {language === "English"
              ? "    School leaving date  "
              : "शाळा सोडल्याची तारीख(माहे सन)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.1in', left: '3.5in' }}>
            {formatDate(formData.date)}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.4in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.5in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Student's Progress"
              : "अभ्यासातील प्रगती"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.5in', left: '3.5in' }}>
            {formData.progress}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.8in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.9in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Student's Conduct "
              : "शाळेतील वर्तणूक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.9in', left: '3.5in' }}>
            {formData.conduct}
          </p>


          <p style={{ position: 'absolute', top: '8.3in', left: '0.4in', fontSize: '0.98em' }}>
            <b>
              {language === "English"
                ? `Class in which studying, since when`
                : `कोणत्या इयत्तेत शिकत ${formData.gender === 'male' ? 'होता' : 'होती'} व केव्हा पासून`}
            </b>
          </p>

          {/* <p style={{ position: 'absolute', top: '8.3in', left: '3.5in' }}>
          {formData.class}- {formData.sinceWhen}
        </p> */}

          <p
            ref={sinceWhenRef}
            style={{
              position: 'absolute',
              top: sinceWhenTop,
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.class} - {formData.sinceWhen}
          </p>


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.2in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '9.54in', left: '0in', right: '0in' }}></div>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.6in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '9.1in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Remarks "
              : "शेरा"}</b>
          </p>
          <p style={{ position: 'absolute', top: '9.1in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.35in', overflow: 'hidden' }}>
            {formData.remark}
          </p>
          <p style={{ position: 'absolute', top: '8.7in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Reason for Leaving"
              : "शाळा सोडल्याचे कारण"}</b>
          </p>
          <p style={{ position: 'absolute', top: '8.65in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.35in', overflow: 'hidden' }}>
            {formData.reason}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '9in', left: '0in', right: '0in' }}></div>
          <p style={{ position: 'absolute', top: '9.58in', left: '0.4in' }}>
            {language === "English"
              ? "  This is to certify that the above information is as per the records of the institution."
              : "दाखला देण्यात येतो की, वरील माहिती शाळेतील जनरल रजिस्टर नंबर १ प्रमाणे आहे."}
          </p>
          {formData.showOwtId === true && (
            <p style={{ position: 'absolute', top: '10.25in', left: '0.3in' }}>
              <strong>{language === "English" ? "O.W. No. : " : "जावक क्र. : "}</strong>{formData.owtId || 'Not Generated'}
            </p>
          )}
          <p style={{ position: 'absolute', top: '10.6in', left: '0.3in' }}>
            {language === "English" ? "Date :" : "दि :"} {formatDate(formData.printdate)}
          </p>
          <p style={{ position: 'absolute', top: '10.6in', right: '0.6in' }}>
            {isPrincipal && isDean && isHeadmaster
              ? language === "English"
                ? "Principal / Dean / Headmaster"
                : "प्राचार्य / डीन / मुख्याध्यापक"
              : isPrincipal && isDean
                ? language === "English"
                  ? "Principal / Dean"
                  : "प्राचार्य / डीन"
                : isPrincipal && isHeadmaster
                  ? language === "English"
                    ? "Principal / Headmaster"
                    : "प्राचार्य / मुख्याध्यापक"
                  : isDean && isHeadmaster
                    ? language === "English"
                      ? "Dean / Headmaster"
                      : "डीन / मुख्याध्यापक"
                    : isPrincipal
                      ? language === "English"
                        ? "Principal"
                        : "प्राचार्य"
                      : isDean
                        ? language === "English"
                          ? "Dean"
                          : "डीन"
                        : isHeadmaster
                          ? language === "English"
                            ? "Headmaster"
                            : "मुख्याध्यापक"
                          : language === "English"
                            ? "Principal / Dean / Headmaster"
                            : "प्राचार्य / डीन / मुख्याध्यापक"}
          </p>

          <p style={{ position: 'absolute', top: '10.6in', right: '3.6in' }}>
            {language === "English"
              ? "Clerk"
              : "लिपिक"}
          </p>
        </div>

        <div style={{ height: '200px' }}>
        </div>
      </>
    );
  };


  const renderContent2 = () => {
    if (!schoolData || !formData) return null;


    return (
      <>
        <div
          style={{
            marginBottom: '300px ',
            position: 'absolute',
            top: '0.80in',
            bottom: '0in',
            right: '0.35in', // Aligns the right edge of the box with the right edge of the page 
            width: '7.6in',  // 8.5in - 0.4in (0.2in on each side)
            height: '11in', // 11in - 0.4in (0.2in on each side)
            fontFamily: "'NotoSansDevanagari', sans-serif",
            border: '0.03in solid black',
            boxSizing: 'border-box',
            padding: '0.2in', // Add padding to create margin inside the border

            '@media (max-width: 1200px)': {  // For screens narrower than 1200px
              right: '0in',
              width: '8in',
              height: '11in',
            },
            '@media (max-width: 992px)': {  // For screens narrower than 992px
              right: '0in',
              width: '8.5in',
              height: '11.5in',
            },
            '@media (max-width: 768px)': {  // For screens narrower than 768px
              top: '0.2in',
              right: '0in',
              width: '100%',
              height: 'auto',
              padding: '0.1in',
            },
          }}
        >

          <div
            style={{
              position: 'absolute',
              top: '0.05in',
              left: '0in',
              right: '0in',
              textAlign: 'center',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {schoolData.sansthaName && (
                <div
                  style={{
                    fontSize: '10.4px',
                    fontWeight: 'bold',
                    wordWrap: 'break-word',
                    textAlign: 'center',
                    marginBottom: '-10px',
                  }}
                >
                  {schoolData.sansthaName}
                </div>
              )}
              <div
                style={{
                  fontSize: '19px',
                  fontWeight: 'bold',
                  wordWrap: 'break-word',
                  textAlign: 'center',
                  marginTop: schoolData.sansthaName ? '15px' : '0px',
                }}
              >
                {schoolData.schoolName}
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '0.49in',
                  left: '15%',
                  right: '15%',
                  boxSizing: 'border-box',
                  padding: '0',
                }}
              >
                <div
                  style={{
                    margin: '0 auto',
                    width: '100%',
                    maxWidth: 'calc(100% - 0.6in)',
                    boxSizing: 'border-box',
                    textAlign: 'center',
                  }}
                >
                  <p style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    wordWrap: 'break-word',
                    display: 'inline-block',
                  }}>

                  </p>
                  <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
                    {language === 'English' ? (
                      <>
                        <strong>Taluka : </strong>{schoolData.taluka},<strong> District :</strong> {schoolData.jilha}
                      </>
                    ) : (
                      <>
                        <strong> तालुका : </strong>{schoolData.taluka}, <strong>जिल्हा :</strong> {schoolData.jilha}
                      </>
                    )}
                  </p>

                  <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
                    {language === 'English' ? (
                      <>
                        <strong>UDISE No :</strong> {schoolData.udiseNumber}, <strong>Board :</strong> {schoolData.boardName}
                      </>
                    ) : (
                      <>
                        <strong>UDISE क्र :</strong> {schoolData.udiseNumber}, <strong>बोर्ड :</strong> {schoolData.boardName}
                      </>
                    )}
                  </p>

                  <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
                    {language === 'English' ? (
                      <>
                        <strong>Phone No :</strong> {schoolData.mobileNumber}, <strong>Email :</strong> {schoolData.email}
                      </>
                    ) : (
                      <>
                        <strong>दूरध्वनी क्र :</strong> {schoolData.mobileNumber}, <strong>ई-मेल :</strong> {schoolData.email}
                      </>
                    )}
                  </p>

                  <div style={{ textAlign: 'left', whiteSpace: 'nowrap', fontSize: '13px', lineHeight: '1.4' }}>
                    <p style={{ margin: '2px 0', padding: '0' }}>
                      {language === 'English' ? (
                        <>
                          <strong>School Code :</strong> {schoolData.schoolCode || ""}
                          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          <strong>Affiliation No :</strong> {schoolData.sanlagnataKramank || ""}
                        </>
                      ) : (
                        <>
                          <strong>शाळा कोड :</strong> {schoolData.schoolCode || ""}
                          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          <strong>संलग्नता क्र :</strong> {schoolData.sanlagnataKramank || ""}
                        </>
                      )}
                    </p>
                  </div>


                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: '1.3in',
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
              }}
            >
              {logoURL && (
                <img
                  src={logoURL}
                  alt="School Logo"
                  style={{
                    position: 'absolute',
                    top: '0.73in',
                    left: '0.2in', width: '110px', height: '100px', marginRight: '10px'
                  }}
                />
              )}

            </div>
            <div
              style={{
                marginTop: '1.3in',
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'center',
              }}
            >
              {logoURL2 && (
                <img
                  src={logoURL2}
                  alt=""
                  style={{
                    position: 'absolute',
                    top: '0.66in',
                    right: '0.2in', width: '110px', height: '100px', marginRight: '10px'
                  }}
                />
              )}

            </div>




          </div>

          <div
            style={{
              position: 'absolute',
              top: '2.2in',
              left: '2.6in',
              width: '2.55in',
              height: '0.32in',
              textAlign: 'center',
              border: '0.025in solid black',
              margin: '10px 0',
              backgroundColor: 'black', // add this
              color: 'white', // add this
              borderRadius: '0.1in', // add this
              printColorAdjust: 'exact',
              WebkitPrintColorAdjust: 'exact',
            }}
          >
            <h3 style={{ color: 'white', fontSize: '17px', margin: '5px 0', fontWeight: 'bolder' }}>
              <p>
                {language === "English"
                  ? "School Leaving Certificate"
                  : "शाळा सोडल्याचे प्रमाणपत्र"}
              </p>
            </h3>
          </div>
          {showDuplicateText && (
            <p style={{ position: 'absolute', top: '1.85in', left: '1.5in', fontSize: '18px', color: 'red' }}>
              {duplicate && language === "English" ? (
                <>
                  <>Duplicate</>
                </>
              ) : duplicate && language !== "English" ? (
                <>
                  <strong>दुबारप्रत</strong>
                </>
              ) : (
                <></>
              )}
            </p>
          )}
          <p style={{ position: 'absolute', top: '1.75in', left: '5.84in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Book No :</strong> {formData.bookno}
              </>
            ) : (
              <>
                <strong>बूक क्र :</strong> {formData.bookno}
              </>
            )}
          </p>


          <p style={{ position: 'absolute', top: '1.95in', left: '5.84in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Medium :</strong> {schoolData.madhyam}
              </>
            ) : (
              <>
                <strong>माध्यम :</strong> {schoolData.madhyam}
              </>
            )}
          </p>




          {isFreeTrial && (
            <img
              src={Watermark}
              alt="Free Trial Watermark"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(-10deg)",
                width: "80%",
                opacity: 0.2,
                pointerEvents: "none",
                zIndex: 0
              }}
            />
          )}



          <p style={{ position: 'absolute', top: '1.9in', left: '0.25in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                {documentNumber || 'Not Generated'}
              </>
            ) : (
              <>
                {documentNumber || 'Not Generated'}
              </>
            )}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.7in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.2in', left: '0in', right: '0in' }}></div>
          <div style={{ borderLeft: '0.02in solid black', position: 'absolute', top: '3.5in', left: '3.44in', height: '5.9in', }}></div>

          {/* <p style={{ position: 'absolute', top: '1.9in', left: '5.8in', fontSize: '12px' }}>
          Document No.: {formData.documentNo}
        </p> */}



          <p style={{ position: 'absolute', top: '2.8in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>GR. No. :</strong> {formData.registerno}
              </>
            ) : (
              <>
                <strong>रजिस्टर क्र :</strong> {formData.registerno}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.05in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>SARAL ID :</strong> {formData.studentId}
              </>
            ) : (
              <>
                <strong>सरल आयडी :</strong> {formData.studentId}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.3in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>APAAR ID :</strong> {formData.aparId}
              </>
            ) : (
              <>
                <strong>अपार आयडी :</strong> {formData.aparId}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '2.8in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission date :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            ) : (
              <>
                <strong>प्रवेशाची तारीख :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            )}
          </p>
          <p style={{ position: 'absolute', top: '3.05in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission Class :</strong> {formData.admissionClass}
              </>
            ) : (
              <>
                <strong>प्रवेश वर्ग :</strong> {formData.admissionClass}
              </>
            )}
          </p>
          <p style={{ position: 'absolute', top: '3.3in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Mother Tounge :</strong> {formData.motherTounge}
              </>
            ) : (
              <>
                <strong>मातृभाषा :</strong> {formData.motherTounge}
              </>
            )}
          </p>


          <p style={{ position: 'absolute', top: '2.8in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Educational Year :</strong> {formData.educationalYear}
              </>
            ) : (
              <>
                <strong>शैक्षणिक वर्ष :</strong> {formData.educationalYear}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.05in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Aadhar Card No :</strong> {formData.stdAdharNo}
              </>
            ) : (
              <>
                <strong>विद्यार्थी आधार क्र :</strong> {formData.stdAdharNo}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.3in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>PEN No :</strong> {formData.panId}
              </>
            ) : (
              <>
                <strong>PEN क्र :</strong> {formData.panId}
              </>
            )}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.5in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '3.6in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Full Name of Student"
              : "विद्यार्थ्याचे संपूर्ण नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '3.6in', left: '3.5in' }}>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.9in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4in', left: '0.4in' }}>
            <b> {language === "English"
              ? "  Mother's Name"
              : "आईचे नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4in', left: '3.5in' }}>
            {formData.stdMother}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.3in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.4in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Religion"
              : "धर्म "}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.4in', left: '3.5in' }}>
            {formData.religion}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.8in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Caste- Sub Caste"
              : "जात-पोटजात"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.8in', left: '3.5in' }}>
            {formData.caste && formData.subCaste
              ? `${formData.caste} - ${formData.subCaste}`
              : formData.caste || formData.subCaste}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.1in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.2in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Nationality  "
              : "राष्ट्रीयत्व"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.2in', left: '3.5in' }}>
            {formData.nationality}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.5in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.55in', left: '0.4in' }}>
            <b> {language === "English"
              ? " Date of Birth "
              : "जन्म दिनांक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.8in', left: '0.4in' }}>
            <b>{language === "English"
              ? "(Numerical and in words) "
              : "(अंकी व अक्षरी)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.55in', left: '3.5in' }}>
            {moment(formData.dob).format('DD-MM-YYYY')} </p>

          <p style={{ position: 'absolute', top: '5.8in', left: '3.5in' }}>
            {formData.dobInWords}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.1in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '6.2in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Place of Birth  "
              : "जन्म स्थळ"}</b>
          </p>
          <p
            ref={birthPlaceRef}
            style={{
              position: 'absolute',
              top: birthPlaceTop,
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.birthPlace}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.5in', left: '0in', right: '0in' }}></div>


          <p style={{ position: 'absolute', top: '6.65in', left: '0.4in', fontSize: '0.99em' }}>
            <b> {language === "English"
              ? "Previous School Name "
              : "या शाळेत येण्यापूर्वी शिकत असलेली शाळा"}</b>
          </p>

          <p style={{ position: 'absolute', top: '6.56in', left: '3.5in', fontSize: '0.8em' }}>
            {formData.prevSchool}
          </p>


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.1in', left: '0.4in' }}>
            <b> {language === "English"
              ? "    School leaving date  "
              : "शाळा सोडल्याची तारीख(माहे सन)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.1in', left: '3.5in' }}>
            {formatDate(formData.date)}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.4in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.5in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Student's Progress"
              : "अभ्यासातील प्रगती"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.5in', left: '3.5in' }}>
            {formData.progress}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.8in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.9in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Student's Conduct "
              : "शाळेतील वर्तणूक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.9in', left: '3.5in' }}>
            {formData.conduct}
          </p>


          <p style={{ position: 'absolute', top: '8.3in', left: '0.4in', fontSize: '0.98em' }}>
            <b>
              {language === "English"
                ? `Class in which studying, since when`
                : `कोणत्या इयत्तेत शिकत ${formData.gender === 'male' ? 'होता' : 'होती'} व केव्हा पासून`}
            </b>
          </p>


          <p
            ref={sinceWhenRef}
            style={{
              position: 'absolute',
              top: sinceWhenTop,
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.class} - {formData.sinceWhen}
          </p>


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.2in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '9.4in', left: '0in', right: '0in' }}></div>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.6in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '9.15in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Remarks "
              : "शेरा"}</b>
          </p>
          <p style={{ position: 'absolute', top: '9.15in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.45in', overflow: 'hidden' }}>
            {formData.remark}
          </p>
          <p style={{ position: 'absolute', top: '8.65in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Reason for Leaving"
              : "शाळा सोडल्याचे कारण"}</b>
          </p>
          <p style={{ position: 'absolute', top: '8.65in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.45in', overflow: 'hidden' }}>
            {formData.reason}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '9.1in', left: '0in', right: '0in' }}></div>
          <p style={{ position: 'absolute', top: '9.6in', left: '0.8in', fontSize: '14px' }}>
            {language === "English"
              ? "Certified that, the above information is in accordance with school General Register No.1."
              : "दाखला देण्यात येतो की, वरील माहिती शाळेतील जनरल रजिस्टर नंबर १ प्रमाणे आहे."}
          </p>


          <p style={{ position: 'absolute', top: '9.85in', left: '0.2in' }}>
            {language === "English" ? "O.W.No" : "जा. क्र. "} ............................
          </p>
          <p style={{ position: 'absolute', top: '9.83in', left: '0.9in' }}>
            {formData.showOwtId === true ? formData.owtId : ''}
          </p>



          <p style={{ position: 'absolute', top: '9.85in', left: '2.1in' }}>
            {language === "English" ? "Date" : "दि "} ...........................
          </p>
          <p style={{ position: 'absolute', top: '9.83in', left: '2.8in' }}>
            {year}
          </p>

          <p style={{ position: 'absolute', top: '9.85in', left: '3.7in' }}>
            {language === "English" ? "Month" : "महिना"} ..........................
          </p>
          <p style={{ position: 'absolute', top: '9.83in', left: '4.5in' }}>
            {month}
          </p>

          <p style={{ position: 'absolute', top: '9.85in', left: '5.5in' }}>
            {language === "English" ? "Year" : "वर्ष"} ................................
          </p>
          <p style={{ position: 'absolute', top: '9.83in', left: '6.2in' }}>
            {day}
          </p>




          <p style={{ position: 'absolute', top: '10.32in', left: '0.2in', color: 'black' }}>
            {language === "English"
              ? "Class Teacher"
              : "वर्गशिक्षक"}
          </p>

          <p style={{ position: 'absolute', top: '10.32in', left: '2.4in', color: 'black' }}>
            {language === "English"
              ? "Clerk"
              : "लिपिक"}
          </p>


          <p style={{ position: 'absolute', top: '10.32in', left: '4in', color: 'black' }}>
            {language === "English"
              ? "Checked by"
              : "पडताळणी केली"}
          </p>

          <p style={{ position: 'absolute', top: '10.32in', left: '6.2in', color: 'black' }}>
            {language === "English"
              ? "Headmaster"
              : "मुख्याध्यापक"}
          </p>




          <p style={{ position: 'absolute', left: '0in', fontSize: '12px', top: '10.6in', borderTop: '1px solid black', paddingLeft: '3px', textAlign: 'center' }}>

            {language === "English"
              ? " Note :- No changes in any entry in this certificate will be made except by the authority issuing in that the Infringement of the rule will be punished in Accordance with the legal Provision."
              : " या दाखल्यात शाळेच्या मुख्याध्यापकाशिवाय कोणत्याही प्रकारचा फेरबदल करू नये .तसे केल्यास तो गंभीर प्रकारचा गुन्हा समजण्यात येऊन अपराधी शिक्षेस पात्र होईल."}</p>


        </div>

        <div style={{ height: '200px' }}>
        </div>
      </>
    );
  };

  const renderContent3 = () => {
    if (!schoolData || !formData) return null;


    return (
      <>
        <div
          style={{
            marginBottom: '300px ',
            position: 'absolute',
            top: '0.80in',
            bottom: '0in',
            right: '0.35in', // Aligns the right edge of the box with the right edge of the page
            width: '7.6in',  // 8.5in - 0.4in (0.2in on each side)
            height: '11in', // 11in - 0.4in (0.2in on each side)
            fontFamily: "'NotoSansDevanagari', sans-serif",
            border: '0.03in solid black',
            boxSizing: 'border-box',
            padding: '0.2in', // Add padding to create margin inside the border
            // Responsive adjustments
            '@media (max-width: 1200px)': {  // For screens narrower than 1200px
              right: '0in',
              width: '8in',
              height: '11in',
            },
            '@media (max-width: 992px)': {  // For screens narrower than 992px
              right: '0in',
              width: '8.5in',
              height: '11.5in',
            },
            '@media (max-width: 768px)': {  // For screens narrower than 768px
              top: '0.2in',
              right: '0in',
              width: '100%',
              height: 'auto',
              padding: '0.1in',
            },
          }}
        >

          <div
            style={{
              position: 'absolute',
              top: '0.1in',
              left: '0in',
              right: '0in',
              textAlign: 'center',
            }}
          >
            {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    {schoolData.sansthaName && (
      <div
        style={{
          fontSize: '10.4px',
          fontWeight: 'bold',
          wordWrap: 'break-word',
          textAlign: 'center',
          marginBottom: '-10px', // add this
        }}
      >
        {schoolData.sansthaName}
      </div>
    )}
    <div
      style={{
        fontSize: '19px',
        fontWeight: 'bold',
        wordWrap: 'break-word',
        textAlign: 'center',
        marginTop: schoolData.sansthaName ? '10px' : '0px',
      }}
    >
      {schoolData.schoolName}
    </div>
    <div
          style={{
            position: 'absolute',
            top: '0.3in',
            left: '15%',
            right: '15%',
            boxSizing: 'border-box',
            padding: '0',
          }}
        >
          <div
            style={{
              margin: '0 auto',
              width: '100%',
              maxWidth: 'calc(100% - 0.6in)',
              boxSizing: 'border-box',
              textAlign: 'center',
            }}
          >
          <p  style={{
             fontSize: '18px',
             fontWeight: 'bold',
             wordWrap: 'break-word',
             display: 'inline-block',
           }}>
  
          </p>
          <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
    {language === 'English' ? (
      <>
      <strong>Taluka : </strong>{schoolData.taluka},<strong> District :</strong> {schoolData.jilha}
      </>
    ) : (
      <>
      <strong> तालुका : </strong>{schoolData.taluka}, <strong>जिल्हा :</strong> {schoolData.jilha}
      </>
    )}
  </p>
  
  <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
    {language === 'English' ? (
      <>
        <strong>UDISE No :</strong> {schoolData.udiseNumber}, <strong>Board :</strong> {schoolData.boardName}
      </>
    ) : (
      <>
        <strong>UDISE क्र :</strong> {schoolData.udiseNumber}, <strong>बोर्ड :</strong> {schoolData.boardName}
      </>
    )}
  </p>
  
  <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
    {language === 'English' ? (
      <>
        <strong>Phone No :</strong> {schoolData.mobileNumber}, <strong>Email :</strong> {schoolData.email}
      </>
    ) : (
      <>
        <strong>दूरध्वनी क्र :</strong> {schoolData.mobileNumber}, <strong>ई-मेल :</strong> {schoolData.email}
      </>
    )}
  </p>
  
  <div style={{ textAlign: 'left', whiteSpace: 'nowrap', fontSize: '13px', lineHeight: '1.4' }}>
    <p style={{ margin: '2px 0', padding: '0' }}>
      {language === 'English' ? (
        <>
          <strong>Affiliation No :</strong> {schoolData.sanlagnataKramank}
          <br />
          <strong>Recognition No :</strong> {schoolData.manyataKramank}
        </>
      ) : (
        <>
          <strong>संलग्नता क्र :</strong> {schoolData.sanlagnataKramank}
          <br />
          <strong>मान्यता क्र :</strong> {schoolData.manyataKramank}
        </>
      )}
    </p>
  </div>
  
  
          </div>
        </div>
  </div> */}
            {/* <div
      style={{
        marginTop: '1.4in',
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
      }}
    >
      {logoURL && (
        <img
          src={logoURL}
          alt="School Logo"
          style={{ position: 'absolute',
      top: '0.55in',
      left: '0.3in', width: '110px', height: '110px', marginRight: '10px' }}
        />
      )}
     
    </div> */}

          </div>

          <div
            style={{
              position: 'absolute',
              top: '2.2in',
              left: '2.5in',
              width: '2.55in',
              height: '0.32in',
              textAlign: 'center',
              border: '0.025in solid black',
              margin: '10px 0',
              backgroundColor: 'black', // add this
              color: 'white', // add this
              borderRadius: '0.1in', // add this
              printColorAdjust: 'exact',
              WebkitPrintColorAdjust: 'exact',
            }}
          >
            <h3 style={{ color: 'white', fontSize: '17px', margin: '5px 0', fontWeight: 'bolder' }}>
              <p>
                {language === "English"
                  ? "School Leaving Certificate"
                  : "शाळा सोडल्याचे प्रमाणपत्र"}
              </p>
            </h3>
          </div>
          {showDuplicateText && (


            <p style={{ position: 'absolute', top: '1.85in', left: '1.5in', fontSize: '18px', color: 'red' }}>
              {duplicate && language === "English" ? (
                <>
                  <>Duplicate</>
                </>
              ) : duplicate && language !== "English" ? (
                <>
                  <strong>दुबारप्रत</strong>
                </>
              ) : (
                <></>
              )}
            </p>
          )}

          <p style={{ position: 'absolute', top: '2.23in', left: '5.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Book No :</strong> {formData.bookno}
              </>
            ) : (
              <>
                <strong>बूक क्र :</strong> {formData.bookno}
              </>
            )}
          </p>


          <p style={{ position: 'absolute', top: '2.44in', left: '5.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Medium :</strong> {schoolData.madhyam}
              </>
            ) : (
              <>
                <strong>माध्यम :</strong> {schoolData.madhyam}
              </>
            )}
          </p>


          {isFreeTrial && (
            <img
              src={Watermark}
              alt="Free Trial Watermark"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(-10deg)",
                width: "80%",
                opacity: 0.2,
                pointerEvents: "none",
                zIndex: 0
              }}
            />
          )}

          <p style={{ position: 'absolute', top: '2.35in', left: '0.25in', fontSize: '13px' }}>
            {documentNumber || 'Not Generated'}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.7in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.2in', left: '0in', right: '0in' }}></div>
          <div style={{ borderLeft: '0.02in solid black', position: 'absolute', top: '3.5in', left: '3.44in', height: '5.9in', }}></div>

          {/* <p style={{ position: 'absolute', top: '1.9in', left: '5.8in', fontSize: '12px' }}>
          Document No.: {formData.documentNo}
        </p> */}



          <p style={{ position: 'absolute', top: '2.8in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>GR. No. :</strong> {formData.registerno}
              </>
            ) : (
              <>
                <strong>रजिस्टर क्र :</strong> {formData.registerno}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.05in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>SARAL ID :</strong> {formData.studentId}
              </>
            ) : (
              <>
                <strong>सरल आयडी :</strong> {formData.studentId}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.3in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>APAAR ID :</strong> {formData.aparId}
              </>
            ) : (
              <>
                <strong>अपार आयडी :</strong> {formData.aparId}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '2.8in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission date :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            ) : (
              <>
                <strong>प्रवेशाची तारीख :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            )}
          </p>
          <p style={{ position: 'absolute', top: '3.05in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission Class :</strong> {formData.admissionClass}
              </>
            ) : (
              <>
                <strong>प्रवेश वर्ग :</strong> {formData.admissionClass}
              </>
            )}
          </p>
          <p style={{ position: 'absolute', top: '3.3in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Mother Tounge :</strong> {formData.motherTounge}
              </>
            ) : (
              <>
                <strong>मातृभाषा :</strong> {formData.motherTounge}
              </>
            )}
          </p>








          <p style={{ position: 'absolute', top: '2.8in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Educational Year :</strong> {formData.educationalYear}
              </>
            ) : (
              <>
                <strong>शैक्षणिक वर्ष :</strong> {formData.educationalYear}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.05in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Aadhar Card No :</strong> {formData.stdAdharNo}
              </>
            ) : (
              <>
                <strong>विद्यार्थी आधार क्र :</strong> {formData.stdAdharNo}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.3in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>PEN No :</strong> {formData.panId}
              </>
            ) : (
              <>
                <strong>PEN क्र :</strong> {formData.panId}
              </>
            )}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.5in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '3.6in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Full Name of Student"
              : "विद्यार्थ्याचे संपूर्ण नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '3.6in', left: '3.5in' }}>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.9in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4in', left: '0.4in' }}>
            <b> {language === "English"
              ? "  Mother's Name"
              : "आईचे नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4in', left: '3.5in' }}>
            {formData.stdMother}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.3in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.4in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Religion"
              : "धर्म "}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.4in', left: '3.5in' }}>
            {formData.religion}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.8in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Caste- Sub Caste"
              : "जात-पोटजात"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.8in', left: '3.5in' }}>
            {formData.caste && formData.subCaste
              ? `${formData.caste} - ${formData.subCaste}`
              : formData.caste || formData.subCaste}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.1in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.2in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Nationality  "
              : "राष्ट्रीयत्व"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.2in', left: '3.5in' }}>
            {formData.nationality}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.5in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.55in', left: '0.4in' }}>
            <b> {language === "English"
              ? " Date of Birth "
              : "जन्म दिनांक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.8in', left: '0.4in' }}>
            <b>{language === "English"
              ? "(Numerical and in words) "
              : "(अंकी व अक्षरी)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.55in', left: '3.5in' }}>
            {moment(formData.dob).format('DD-MM-YYYY')} </p>

          <p style={{ position: 'absolute', top: '5.8in', left: '3.5in' }}>
            {formData.dobInWords}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.1in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '6.2in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Place of Birth  "
              : "जन्म स्थळ"}</b>
          </p>
          <p
            ref={birthPlaceRef}
            style={{
              position: 'absolute',
              top: birthPlaceTop,
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.birthPlace}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.5in', left: '0in', right: '0in' }}></div>


          <p style={{ position: 'absolute', top: '6.65in', left: '0.4in', fontSize: '0.99em' }}>
            <b> {language === "English"
              ? "Previous School Name "
              : "या शाळेत येण्यापूर्वी शिकत असलेली शाळा"}</b>
          </p>

          <p style={{ position: 'absolute', top: '6.56in', left: '3.5in', fontSize: '0.8em' }}>
            {formData.prevSchool}
          </p>


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.1in', left: '0.4in' }}>
            <b> {language === "English"
              ? "    School leaving date  "
              : "शाळा सोडल्याची तारीख(माहे सन)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.1in', left: '3.5in' }}>
            {formatDate(formData.date)}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.4in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.5in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Student's Progress"
              : "अभ्यासातील प्रगती"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.5in', left: '3.5in' }}>
            {formData.progress}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.8in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.9in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Student's Conduct "
              : "शाळेतील वर्तणूक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.9in', left: '3.5in' }}>
            {formData.conduct}
          </p>


          <p style={{ position: 'absolute', top: '8.3in', left: '0.4in', fontSize: '0.98em' }}>
            <b>
              {language === "English"
                ? `Class in which studying, since when`
                : `कोणत्या इयत्तेत शिकत ${formData.gender === 'male' ? 'होता' : 'होती'} व केव्हा पासून`}
            </b>
          </p>


          <p
            ref={sinceWhenRef}
            style={{
              position: 'absolute',
              top: sinceWhenTop,
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.class} - {formData.sinceWhen}
          </p>


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.2in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '9.4in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.6in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '9.1in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Remarks "
              : "शेरा"}</b>
          </p>
          <p style={{ position: 'absolute', top: '9.1in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.35in', overflow: 'hidden' }}>
            {formData.remark}
          </p>
          <p style={{ position: 'absolute', top: '8.7in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Reason for Leaving"
              : "शाळा सोडल्याचे कारण"}</b>
          </p>
          <p style={{ position: 'absolute', top: '8.7in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.3in', overflow: 'hidden' }}>
            {formData.reason}
          </p>


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '9in', left: '0in', right: '0in' }}></div>
          <p style={{ position: 'absolute', top: '9.48in', left: '0.4in' }}>
            {language === "English"
              ? "  This is to certify that the above information is as per the records of the institution."
              : "दाखला देण्यात येतो की, वरील माहिती शाळेतील जनरल रजिस्टर नंबर १ प्रमाणे आहे."}
          </p>


          {formData.showOwtId === true && (
            <p style={{ position: 'absolute', top: '9.9in', left: '0.3in' }}>
              <strong>{language === "English" ? "O.W. No. : " : "जावक क्र. : "}</strong>{formData.owtId || 'Not Generated'}
            </p>
          )}
          <p style={{ position: 'absolute', top: '10.3in', left: '0.3in' }}>
            {language === "English" ? "Date :" : "दि :"} {formatDate(formData.printdate)}
          </p>
          <p style={{ position: 'absolute', top: '10.3in', right: '0.5in' }}>

            {isPrincipal && isDean
              ? language === "English" ? "Principal / Dean" : "प्राचार्य/मुख्याध्यापक"
              : isPrincipal
                ? language === "English" ? "Principal" : "मुख्याध्यापक"
                : isDean
                  ? language === "English" ? "Dean" : "प्राचार्य "
                  : language === "English" ? "Principal/ Dean" : "प्राचार्य/मुख्याध्यापक"
            }
          </p>

          <p style={{ position: 'absolute', top: '10.3in', right: '3in' }}>
            {language === "English"
              ? "Clerk/Class Teacher"
              : "लिपिक/ वर्गशिक्षक "}
          </p>


          <p style={{ position: 'absolute', left: '0in', fontSize: '12px', top: '10.6in', borderTop: '1px solid black', paddingLeft: '3px' }}>

            {language === "English"
              ? "Note :- No changes in any entry in this certificate will be made except by the authority issuing in that the Infringement of the rule will be punished in Accordance with the legal Provision."
              : "या दाखल्यात शाळेच्या मुख्याध्यापकाशिवाय कोणत्याही प्रकारचा फेरबदल करू नये .तसे केल्यास तो गंभीर प्रकारचा गुन्हा समजण्यात येऊन अपराधी शिक्षेस पात्र होईल."}</p>

        </div>

        <div style={{ height: '200px' }}>
        </div>
      </>
    );
  };



  const renderContent4 = () => {
    if (!schoolData || !formData) return null;

    const getNamePart = (name, lang) => {
      if (!name) return '';
      const parts = name.split('/');
      if (parts.length > 1) {
        if (lang === 'English') return parts[0].trim();
        if (lang === 'Marathi') return parts[1].trim();
      }
      return name;
    };


    return (
      <>
        <div
          style={{
            marginBottom: '300px ',
            position: 'absolute',
            top: '0.80in',
            bottom: '0in',
            right: '0.35in', // Aligns the right edge of the box with the right edge of the page
            width: '7.6in',  // 8.5in - 0.4in (0.2in on each side)
            height: '11in', // 11in - 0.4in (0.2in on each side)
            fontFamily: "'NotoSansDevanagari', sans-serif",
            border: '0.03in solid black',
            boxSizing: 'border-box',
            padding: '0.2in', // Add padding to create margin inside the border
            // Responsive adjustments
            '@media (max-width: 1200px)': {  // For screens narrower than 1200px
              right: '0in',
              width: '8in',
              height: '11in',
            },
            '@media (max-width: 992px)': {  // For screens narrower than 992px
              right: '0in',
              width: '8.5in',
              height: '11.5in',
            },
            '@media (max-width: 768px)': {  // For screens narrower than 768px
              top: '0.2in',
              right: '0in',
              width: '100%',
              height: 'auto',
              padding: '0.1in',
            },
          }}
        >

          <div
            style={{
              position: 'absolute',
              top: '0.1in',
              left: '0in',

              textAlign: 'left',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '20px' }}>
              {schoolData.sansthaName && (
                <div
                  style={{
                    fontSize: '10.4px',
                    fontWeight: 'bold',
                    wordWrap: 'break-word',
                    textAlign: 'left',
                    marginBottom: '-10px', // add this
                  }}
                >
                  {schoolData.sansthaName}
                </div>
              )}
              <div
                style={{
                  fontSize: '19px',
                  fontWeight: 'bold',
                  wordWrap: 'break-word',
                  textAlign: 'left',
                  marginTop: schoolData.sansthaName ? '10px' : '0px', lineHeight: '1.1'
                }}
              >
                {schoolData.schoolName}
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '0.35in',
                  left: '-2%',
                  right: '15%',
                  boxSizing: 'border-box',
                  padding: '0',
                }}
              >
                <div
                  style={{
                    margin: '0 auto',
                    width: '100%',
                    maxWidth: 'calc(100% - 0.6in)',
                    boxSizing: 'border-box',
                  }}
                >



                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'auto auto auto auto',
                      columnGap: '20px',
                      rowGap: '4px',
                      fontSize: '14px',
                      marginTop: '10px',
                      alignItems: 'center'
                    }}
                  >
                    {language === 'English' ? (
                      <>
                        <strong style={{ whiteSpace: 'nowrap' }}>Taluka :</strong>
                        <span style={{ whiteSpace: 'nowrap' }}>{schoolData.taluka}</span>

                        <strong style={{ whiteSpace: 'nowrap' }}>District :</strong>
                        <span style={{ whiteSpace: 'nowrap' }}>{schoolData.jilha}</span>

                        <strong style={{ whiteSpace: 'nowrap' }}>UDISE No :</strong>
                        <span style={{ whiteSpace: 'nowrap' }}>{schoolData.udiseNumber}</span>

                        <strong style={{ whiteSpace: 'nowrap' }}>Board :</strong>
                        <span style={{ whiteSpace: 'nowrap' }}>{schoolData.boardName}</span>
                      </>
                    ) : (
                      <>
                        <strong style={{ whiteSpace: 'nowrap' }}>तालुका :</strong>
                        <span style={{ whiteSpace: 'nowrap' }}>{schoolData.taluka}</span>

                        <strong style={{ whiteSpace: 'nowrap' }}>जिल्हा :</strong>
                        <span style={{ whiteSpace: 'nowrap' }}>{schoolData.jilha}</span>

                        <strong style={{ whiteSpace: 'nowrap' }}>UDISE क्र :</strong>
                        <span style={{ whiteSpace: 'nowrap' }}>{schoolData.udiseNumber}</span>

                        <strong style={{ whiteSpace: 'nowrap' }}>बोर्ड :</strong>
                        <span style={{ whiteSpace: 'nowrap' }}>{schoolData.boardName}</span>
                      </>
                    )}
                  </div>

                </div>

              </div>
            </div>



            <p style={{ position: 'absolute', top: '1in', left: '0.2in', fontSize: '13px' }}>
              {language === 'English' ? (
                <>
                  <strong>Email Id :</strong> {schoolData.email}
                </>
              ) : (
                <>
                  <strong>ई-मेल :</strong> {schoolData.email}
                </>
              )}
            </p>






            <p style={{ position: 'relative', top: '0.9in', left: '0.2in', fontSize: '13px', whiteSpace: 'nowrap' }}>
              {language === 'English' ? (
                <>
                  <strong>Recognition No :</strong> {schoolData.manyataKramank}
                </>
              ) : (
                <>
                  <strong>मान्यता क्र :</strong> {schoolData.manyataKramank}
                </>
              )}
            </p>


            <div
              style={{
                marginTop: '1.4in',
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
              }}
            >
              {logoURL && (
                <img
                  src={logoURL}
                  alt="School Logo"
                  style={{
                    position: 'absolute',
                    top: '0.45in',
                    left: '6in', width: '110px', height: '110px', marginRight: '10px'
                  }}
                />
              )}

            </div>
            <div
              style={{
                marginTop: '1.3in',
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'center',
              }}
            >
              {logoURL2 && (
                <img
                  src={logoURL2}
                  alt=""
                  style={{
                    position: 'absolute',
                    top: '0.52in',
                    right: '0.2in', width: '110px', height: '110px', marginRight: '10px'
                  }}
                />
              )}

            </div>

          </div>

          <div
            style={{
              position: 'absolute',
              top: '1.7in',
              left: '2.6in',
              width: '2.55in',
              height: '0.32in',
              textAlign: 'center',
              border: '0.025in solid black',
              margin: '10px 0',
              backgroundColor: 'black', // add this
              color: 'white', // add this
              borderRadius: '0.1in', // add this
              printColorAdjust: 'exact',
              WebkitPrintColorAdjust: 'exact',
            }}
          >
            <h3 style={{ color: 'white', fontSize: '17px', margin: '5px 0', fontWeight: 'bolder' }}>
              <p>
                {language === "English"
                  ? "School Leaving Certificate"
                  : "शाळा सोडल्याचे प्रमाणपत्र"}
              </p>
            </h3>
          </div>
          {showDuplicateText && (
            <p style={{ position: 'absolute', top: '1.85in', left: '1.5in', fontSize: '18px', color: 'red' }}>
              {duplicate && language === "English" ? (
                <>
                  <>Duplicate</>
                </>
              ) : duplicate && language !== "English" ? (
                <>
                  <strong>दुबारप्रत</strong>
                </>
              ) : (
                <></>
              )}
            </p>
          )}

          {/* <p style={{ position: 'absolute', top: '1.95in', left: '5.5in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Book No :</strong> {formData.bookno}
              </>
            ) : (
              <>
                <strong>बूक क्र :</strong> {formData.bookno}
              </>
            )}
          </p> */}

          <p style={{ position: 'absolute', top: '1.95in', left: '5.2in', fontSize: '13px' }}>
            {language === 'English' ? (
              <>
                <strong>Affiliation No :</strong> {schoolData.sanlagnataKramank}
              </>
            ) : (
              <>
                <strong>संलग्नता क्र :</strong> {schoolData.sanlagnataKramank}
              </>
            )}
          </p>


          <p style={{ position: 'absolute', top: '1.8in', left: '5.5in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Medium :</strong> {schoolData.madhyam}
              </>
            ) : (
              <>
                <strong>माध्यम :</strong> {schoolData.madhyam}
              </>
            )}
          </p>




          {isFreeTrial && (
            <img
              src={Watermark}
              alt="Free Trial Watermark"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(-10deg)",
                width: "80%",
                opacity: 0.2,
                pointerEvents: "none",
                zIndex: 0
              }}
            />
          )}



          <p style={{ position: 'absolute', top: '1.75in', left: '0.25in', fontSize: '13px' }}>
            {documentNumber || 'Not Generated'}
          </p>

          <p style={{ position: 'absolute', top: '1.95in', left: '0.25in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Index No :</strong> {schoolData.indexNumber}
              </>
            ) : (
              <>
                <strong>अनु. क्र :</strong> {schoolData.indexNumber}
              </>
            )}
          </p>


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.5in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.2in', left: '0in', right: '0in' }}></div>
          <div style={{ borderLeft: '0.02in solid black', position: 'absolute', top: '3.3in', left: '3.44in', height: '6.25in', }}></div>



          <p style={{ position: 'absolute', top: '2.3in', left: '0.8in', fontSize: '12px', }}>
            {language === "English"
              ? "  No changes are to be made in any entries, only issuance of leaving certificate by the authorized officer."
              : "टीप :- शाळासोडल्याचे दाखल्यामध्ये अनाधिकृतरित्या बदल केल्यास संबंधितांवर कायदेशीर कारवाई करण्यात येईल."}</p>



          <p style={{ position: 'absolute', top: '2.6in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>GR. No. :</strong> {formData.registerno}
              </>
            ) : (
              <>
                <strong>रजिस्टर क्र :</strong> {formData.registerno}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '2.85in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>SARAL ID :</strong> {formData.studentId}
              </>
            ) : (
              <>
                <strong>सरल आयडी :</strong> {formData.studentId}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.1in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>APAAR ID :</strong> {formData.aparId}
              </>
            ) : (
              <>
                <strong>अपार आयडी :</strong> {formData.aparId}
              </>
            )}
          </p>

          {/* <p style={{ position: 'absolute', top: '2.6in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission date :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            ) : (
              <>
                <strong>प्रवेशाची तारीख :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            )}
          </p> */}
          {/* <p style={{ position: 'absolute', top: '2.85in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission Class :</strong> {formData.admissionClass}
              </>
            ) : (
              <>
                <strong>प्रवेश वर्ग :</strong> {formData.admissionClass}
              </>
            )}
          </p> */}
          <p style={{ position: 'absolute', top: '5.2in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Mother Tounge :</strong> {formData.motherTounge}
              </>
            ) : (
              <>
                <strong>मातृभाषा :</strong> {formData.motherTounge}
              </>
            )}
          </p>








          <p style={{ position: 'absolute', top: '2.6in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Educational Year :</strong> {formData.educationalYear}
              </>
            ) : (
              <>
                <strong>शैक्षणिक वर्ष :</strong> {formData.educationalYear}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '2.85in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Aadhar Card No :</strong> {formData.stdAdharNo}
              </>
            ) : (
              <>
                <strong>विद्यार्थी आधार क्र :</strong> {formData.stdAdharNo}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.1in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>PEN No :</strong> {formData.panId}
              </>
            ) : (
              <>
                <strong>पेन आयडी :</strong> {formData.panId}
              </>
            )}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.3in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '3.35in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Full Name of Student"
              : "विद्यार्थ्याचे संपूर्ण नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '3.35in', left: '3.5in' }}>
            {getNamePart(formData.stdName, 'Marathi')} {getNamePart(formData.stdFather, 'Marathi')} {getNamePart(formData.stdSurname, 'Marathi')}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.6in', left: '0in', right: '0in' }}></div>
          <p style={{ position: 'absolute', top: '3.63in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Full Name of Student"
              : "विद्यार्थ्याचे संपूर्ण नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '3.63in', left: '3.5in' }}>
            {formData.stdNameEnglish || `${getNamePart(formData.stdName, 'English')} ${getNamePart(formData.stdFather, 'English')} ${getNamePart(formData.stdSurname, 'English')}`}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.9in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4in', left: '0.4in' }}>
            <b> {language === "English"
              ? "  Mother's Name"
              : "आईचे नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4in', left: '3.5in' }}>
            {formData.stdMother}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.3in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.4in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Religion"
              : "धर्म "}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.4in', left: '3.5in' }}>
            {formData.religion}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.8in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Caste"
              : "जात"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.8in', left: '3.5in' }}>
            {formData.caste
              ? `${formData.caste}`
              : formData.caste}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.1in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.2in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Nationality  "
              : "राष्ट्रीयत्व"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.2in', left: '3.5in' }}>
            {formData.nationality}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.5in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.55in', left: '0.4in' }}>
            <b> {language === "English"
              ? " Date of Birth "
              : "इ. सनप्रमाणे जन्म दिनांक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.8in', left: '0.4in' }}>
            <b>{language === "English"
              ? "(Numerical and in words) "
              : "(अंकी व अक्षरी)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.55in', left: '3.5in' }}>
            {moment(formData.dob).format('DD-MM-YYYY')} </p>

          <p style={{ position: 'absolute', top: '5.8in', left: '3.5in', fontSize: '0.93em' }}>
            {formData.dobInWords}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.05in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '6.12in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Place of Birth  "
              : "जन्म स्थळ"}</b>
          </p>
          <p
            ref={birthPlaceRef}
            style={{
              position: 'absolute',
              top: '6.12in',
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.birthPlace}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.4in', left: '0in', right: '0in' }}></div>


          <p style={{ position: 'absolute', top: '6.48in', left: '0.4in', fontSize: '0.99em', lineHeight: '1.2' }}>
            <b> {language === "English"
              ? "Previous School Name "
              : "या शाळेत येण्यापूर्वी शिकत असलेली शाळा "}</b> <br />

          </p>

          <p style={{ position: 'absolute', top: '6.48in', left: '3.5in', fontSize: '0.8em' }}>
            {formData.prevSchool}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.7in', left: '0in', right: '0in' }}></div>


          <p style={{ position: 'absolute', top: '6.75in', left: '0.4in' }}>
            <b> {language === "English"
              ? "    School leaving date  "
              : "शाळेत प्रविष्ट झाल्याचे दिनांक व इयत्ता"}</b>
          </p>
          <p style={{ position: 'absolute', top: '6.75in', left: '3.5in' }}>
            {convertDateFormat(formData.dateOfAdmission)}-{formData.admissionClass}
          </p>


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.1in', left: '0.4in' }}>
            <b> {language === "English"
              ? "    School leaving date  "
              : "शाळा सोडल्याची तारीख(माहे सन)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.1in', left: '3.5in' }}>
            {formatDate(formData.date)}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.4in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.5in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Student's Progress"
              : "अभ्यासातील प्रगती"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.5in', left: '3.5in' }}>
            {formData.progress}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.8in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.9in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Student's Conduct "
              : "शाळेतील वर्तणूक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.9in', left: '3.5in' }}>
            {formData.conduct}
          </p>


          <p style={{ position: 'absolute', top: '8.3in', left: '0.4in', fontSize: '0.98em' }}>
            <b>
              {language === "English"
                ? `Class in which studying, since when`
                : `कोणत्या इयत्तेत शिकत ${formData.gender === 'male' ? 'होता' : 'होती'} व केव्हा पासून`}
            </b>
          </p>

          {/* <p style={{ position: 'absolute', top: '8.3in', left: '3.5in' }}>
          {formData.class}- {formData.sinceWhen}
        </p> */}

          <p
            ref={sinceWhenRef}
            style={{
              position: 'absolute',
              top: sinceWhenTop,
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.class} - {formData.sinceWhen}
          </p>


          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.2in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '9.54in', left: '0in', right: '0in' }}></div>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.6in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '9.1in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Remarks "
              : "शेरा"}</b>
          </p>
          <p style={{ position: 'absolute', top: '9.1in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.35in', overflow: 'hidden' }}>
            {formData.remark}
          </p>
          <p style={{ position: 'absolute', top: '8.7in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Reason for Leaving"
              : "शाळा सोडल्याचे कारण"}</b>
          </p>
          <p style={{ position: 'absolute', top: '8.65in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.35in', overflow: 'hidden' }}>
            {formData.reason}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '9in', left: '0in', right: '0in' }}></div>
          <p style={{ position: 'absolute', top: '9.58in', left: '0.4in' }}>
            {language === "English"
              ? "  This is to certify that the above information is as per the records of the institution."
              : "दाखला देण्यात येतो की, वरील माहिती शाळेतील जनरल रजिस्टर प्रमाणे आहे."}
          </p>
          {formData.showOwtId === true && (
            <p style={{ position: 'absolute', top: '10.2in', left: '0.3in' }}>
              <strong>{language === "English" ? "O.W. No. : " : "जावक क्र. : "}</strong>{formData.owtId || 'Not Generated'}
            </p>
          )}
          <p style={{ position: 'absolute', top: '9.8in', left: '0.3in' }}>
            {language === "English" ? "Date :" : "दि :"} {formatDate(formData.printdate)}
          </p>
          <p style={{ position: 'absolute', top: '10.6in', left: '0.3in' }}>
            {language === "English" ? "Date :" : "वर्ग शिक्षक"}
          </p>
          <p style={{ position: 'absolute', top: '10.6in', right: '0.6in' }}>
            {isPrincipal && isDean && isHeadmaster
              ? language === "English"
                ? "Principal / Dean / Headmaster"
                : "प्राचार्य / डीन / मुख्याध्यापक"
              : isPrincipal && isDean
                ? language === "English"
                  ? "Principal / Dean"
                  : "प्राचार्य / डीन"
                : isPrincipal && isHeadmaster
                  ? language === "English"
                    ? "Principal / Headmaster"
                    : "प्राचार्य / मुख्याध्यापक"
                  : isDean && isHeadmaster
                    ? language === "English"
                      ? "Dean / Headmaster"
                      : "डीन / मुख्याध्यापक"
                    : isPrincipal
                      ? language === "English"
                        ? "Principal"
                        : "प्राचार्य"
                      : isDean
                        ? language === "English"
                          ? "Dean"
                          : "डीन"
                        : isHeadmaster
                          ? language === "English"
                            ? "Headmaster"
                            : "मुख्याध्यापक"
                          : language === "English"
                            ? "Principal / Dean / Headmaster"
                            : "प्राचार्य / डीन / मुख्याध्यापक"}
          </p>

          <p style={{ position: 'absolute', top: '10.6in', right: '3.6in' }}>
            {language === "English"
              ? "Clerk"
              : "लिपिक"}
          </p>
        </div>

        <div style={{ height: '200px' }}>
        </div>
      </>
    );
  };



  const renderContent5 = () => {
    if (!schoolData || !formData) return null;

    return (
      <>
        <div
          style={{
            marginBottom: '300px ',
            position: 'absolute',
            top: '0.80in',
            bottom: '0in',
            right: '0.35in', // Aligns the right edge of the box with the right edge of the page
            width: '7.6in',  // 8.5in - 0.4in (0.2in on each side)
            height: '11in', // 11in - 0.4in (0.2in on each side)
            fontFamily: "'NotoSansDevanagari', sans-serif",
            border: '0.03in solid black',
            boxSizing: 'border-box',
            padding: '0.2in', // Add padding to create margin inside the border
            // Responsive adjustments
            '@media (max-width: 1200px)': {  // For screens narrower than 1200px
              right: '0in',
              width: '8in',
              height: '11in',
            },
            '@media (max-width: 992px)': {  // For screens narrower than 992px
              right: '0in',
              width: '8.5in',
              height: '11.5in',
            },
            '@media (max-width: 768px)': {  // For screens narrower than 768px
              top: '0.2in',
              right: '0in',
              width: '100%',
              height: 'auto',
              padding: '0.1in',
            },
          }}
        >

          <div
            style={{
              position: 'absolute',
              top: '0.1in',
              left: '0in',
              right: '0in',
              textAlign: 'center',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {schoolData.sansthaName && (
                <div
                  style={{
                    fontSize: '10.4px',
                    fontWeight: 'bold',
                    wordWrap: 'break-word',
                    textAlign: 'center',
                    marginBottom: '-10px', // add this
                  }}
                >
                  {schoolData.sansthaName}
                </div>
              )}
              <div
                style={{
                  fontSize: '19px',
                  fontWeight: 'bold',
                  wordWrap: 'break-word',
                  textAlign: 'center',
                  marginTop: schoolData.sansthaName ? '10px' : '0px', lineHeight: '1.1'
                }}
              >
                {schoolData.schoolName}
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '0.35in',
                  left: '15%',
                  right: '15%',
                  boxSizing: 'border-box',
                  padding: '0',
                }}
              >
                <div
                  style={{
                    margin: '0 auto',
                    width: '100%',
                    maxWidth: 'calc(100% - 0.6in)',
                    boxSizing: 'border-box',
                    textAlign: 'center',
                  }}
                >
                  <p style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    wordWrap: 'break-word',
                    display: 'inline-block',
                  }}>

                  </p>
                  <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
                    {language === 'English' ? (
                      <>
                        <strong>Taluka : </strong>{schoolData.taluka},<strong> District :</strong> {schoolData.jilha},<strong>Pin Code :</strong> {schoolData.pincode}
                      </>
                    ) : (
                      <>
                        <strong> तालुका : </strong>{schoolData.taluka}, <strong>जिल्हा :</strong> {schoolData.jilha},<strong>पिनकोड :</strong> {schoolData.pincode}
                      </>
                    )}
                  </p>
                  {schoolData.sanlagnataKramank && (
                    <p style={{ fontSize: '14px', margin: '2px 0', padding: '0' }}>
                      {language === 'English' ? (
                        <>
                          Affiliated by {schoolData.sanlagnataKramank}
                        </>
                      ) : (
                        <>
                          संलग्नता {schoolData.sanlagnataKramank}
                        </>
                      )}
                    </p>
                  )}


                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: '1.4in',
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
              }}
            >
              {logoURL && (
                <img
                  src={logoURL}
                  alt="School Logo"
                  style={{
                    position: 'absolute',
                    top: '0.55in',
                    left: '0.28in', width: '110px', height: '110px', marginRight: '10px'
                  }}
                />
              )}

            </div>
            <div
              style={{
                marginTop: '1.3in',
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'center',
              }}
            >
              {logoURL2 && (
                <img
                  src={logoURL2}
                  alt=""
                  style={{
                    position: 'absolute',
                    top: '0.52in',
                    right: '0.2in', width: '110px', height: '110px', marginRight: '10px'
                  }}
                />
              )}

            </div>

          </div>

          <div
            style={{
              position: 'absolute',
              top: '1.73in',
              left: '2.3in',
              width: '3.0in',
              height: '0.32in',
              textAlign: 'center',
              border: '0.025in solid black',
              margin: '10px 0',
              backgroundColor: 'black', // add this
              color: 'white', // add this
              borderRadius: '0.1in', // add this
              printColorAdjust: 'exact',
              WebkitPrintColorAdjust: 'exact',
            }}
          >
            <h3 style={{ color: 'white', fontSize: '16px', margin: '5px 0', fontWeight: 'bolder' }}>
              <p>
                {language === "English"
                  ? "Transfer/Leaving Certificate"
                  : "स्थानांतरण / शाळा सोडल्याचे प्रमाणपत्र"}
              </p>
            </h3>
          </div>
          {showDuplicateText && (
            <p style={{ position: 'absolute', top: '1.85in', left: '1.5in', fontSize: '18px', color: 'red' }}>
              {duplicate && language === "English" ? (
                <>
                  <>Duplicate</>
                </>
              ) : duplicate && language !== "English" ? (
                <>
                  <strong>दुबारप्रत</strong>
                </>
              ) : (
                <></>
              )}
            </p>
          )}






          {isFreeTrial && (
            <img
              src={Watermark}
              alt="Free Trial Watermark"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(-10deg)",
                width: "80%",
                opacity: 0.2,
                pointerEvents: "none",
                zIndex: 0
              }}
            />
          )}



          <p style={{ position: 'absolute', top: '1.9in', left: '0.25in', fontSize: '13px' }}>
            {documentNumber || 'Not Generated'}
          </p>



          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.7in', left: '0in', right: '0in' }}></div>
          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '2.2in', left: '0in', right: '0in' }}></div>
          <div style={{ borderLeft: '0.02in solid black', position: 'absolute', top: '3.5in', left: '3.44in', height: '5.64in', }}></div>



          <p style={{ position: 'absolute', top: '2.3in', left: '0.8in', fontSize: '12px', }}>
            {language === "English"
              ? "  No changes are to be made in any entries, only issuance of leaving certificate by the authorized officer."
              : "या दाखल्यात शाळेच्या मुख्याध्यापकाशिवाय कोणत्याही प्रकारचा फेरबदल करू नये .तसे केल्यास तो गंभीर प्रकारचा गुन्हा"}</p>

          <p style={{ position: 'absolute', top: '2.5in', left: '2.6in', fontSize: '12px' }}>
            {language === "English"
              ? "  Teaching certificate with education will be taken."
              : "समजण्यात येऊन अपराधी शिक्षेस पात्र होईल."}</p>

          <p style={{ position: 'absolute', top: '2.8in', left: '0.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>GR. No. :</strong> {formData.registerno}
              </>
            ) : (
              <>
                <strong>रजिस्टर क्र :</strong> {formData.registerno}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '2.8in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission date :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            ) : (
              <>
                <strong>प्रवेशाची तारीख :</strong> {convertDateFormat(formData.dateOfAdmission)}
              </>
            )}
          </p>
          <p style={{ position: 'absolute', top: '3.05in', left: '2.8in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>Admission Class :</strong> {formData.admissionClass}
              </>
            ) : (
              <>
                <strong>प्रवेश वर्ग :</strong> {formData.admissionClass}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '2.8in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>College Code No :</strong> {schoolData.udiseNumber}
              </>
            ) : (
              <>
                <strong>कॉलेज  कोड क्र. :</strong> {schoolData.udiseNumber}
              </>
            )}
          </p>

          <p style={{ position: 'absolute', top: '3.05in', left: '5.2in', fontSize: '13px' }}>
            {language === "English" ? (
              <>
                <strong>PRN No :</strong> {formData.panId}
              </>
            ) : (
              <>
                <strong>PRN क्र :</strong> {formData.panId}
              </>
            )}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.5in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '3.6in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Full Name of Student"
              : "विद्यार्थ्याचे संपूर्ण नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '3.6in', left: '3.5in' }}>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '3.9in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4in', left: '0.4in' }}>
            <b> {language === "English"
              ? "  Mother's Name"
              : "आईचे नाव"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4in', left: '3.5in' }}>
            {formData.stdMother}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.3in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.4in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Religion"
              : "धर्म "}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.4in', left: '3.5in' }}>
            {formData.religion}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '4.7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '4.8in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Caste- Sub Caste"
              : "जात-पोटजात"}</b>
          </p>
          <p style={{ position: 'absolute', top: '4.8in', left: '3.5in' }}>
            {formData.caste && formData.subCaste
              ? `${formData.caste} - ${formData.subCaste}`
              : formData.caste || formData.subCaste}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.1in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.2in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Nationality  "
              : "राष्ट्रीयत्व"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.2in', left: '3.5in' }}>
            {formData.nationality}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '5.5in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '5.55in', left: '0.4in' }}>
            <b> {language === "English"
              ? " Date of Birth "
              : "इ. सनप्रमाणे जन्म दिनांक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.8in', left: '0.4in' }}>
            <b>{language === "English"
              ? "(Numerical and in words) "
              : "(अंकी व अक्षरी)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '5.55in', left: '3.5in' }}>
            {moment(formData.dob).format('DD-MM-YYYY')} </p>

          <p style={{ position: 'absolute', top: '5.8in', left: '3.5in', fontSize: '0.93em' }}>
            {formData.dobInWords}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.1in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '6.2in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Place of Birth  "
              : "जन्म स्थळ"}</b>
          </p>
          <p
            ref={birthPlaceRef}
            style={{
              position: 'absolute',
              top: birthPlaceTop,
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.birthPlace}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '6.5in', left: '0in', right: '0in' }}></div>


          <p style={{ position: 'absolute', top: '6.65in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Class at the time of leaving"
              : "शाळा सोडतानाची इयत्ता"}</b>
          </p>
          <p style={{ position: 'absolute', top: '6.65in', left: '3.5in', fontSize: '16px' }}>
            {formData.class}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.1in', left: '0.4in' }}>
            <b> {language === "English"
              ? "    Date of Leaving  "
              : "शाळा सोडल्याची तारीख(माहे सन)"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.1in', left: '3.5in' }}>
            {formatDate(formData.date)}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.4in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.5in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Student's Progress"
              : "अभ्यासातील प्रगती"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.5in', left: '3.5in' }}>
            {formData.progress}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '7.8in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '7.9in', left: '0.4in' }}>
            <b> {language === "English"
              ? "Student's Conduct "
              : "शाळेतील वर्तणूक"}</b>
          </p>
          <p style={{ position: 'absolute', top: '7.9in', left: '3.5in' }}>
            {formData.conduct}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.2in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '8.3in', left: '0.4in' }}>
            <b>{language === "English"
              ? "Reason for Leaving"
              : "शाळा सोडल्याचे कारण"}</b>
          </p>
          <p style={{ position: 'absolute', top: '8.25in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.35in', overflow: 'hidden' }}>
            {formData.reason}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '8.6in', left: '0in', right: '0in' }}></div>

          <p style={{ position: 'absolute', top: '8.7in', left: '0.4in' }}>
            <b>{language === "English"
              ? " Remarks "
              : "शेरा"}</b>
          </p>
          <p style={{ position: 'absolute', top: '8.7in', left: '3.5in', fontSize: '0.78em', lineHeight: '1.2', width: '4in', overflowWrap: 'break-word', whiteSpace: 'normal', maxHeight: '0.35in', overflow: 'hidden' }}>
            {formData.remark}
          </p>

          <div style={{ borderTop: '0.02in solid black', position: 'absolute', top: '9.14in', left: '0in', right: '0in' }}></div>
          <p style={{ position: 'absolute', top: '9.18in', left: '0.4in' }}>
            {language === "English"
              ? "  This is to certify that the above information is as per the records of the institution."
              : "दाखला देण्यात येतो की, वरील माहिती शाळेतील जनरल रजिस्टर नंबर १ प्रमाणे आहे."}
          </p>
          {formData.showOwtId === true && (
            <p style={{ position: 'absolute', top: '9.85in', left: '0.3in' }}>
              <strong>{language === "English" ? "O.W. No. : " : "जावक क्र. : "}</strong>{formData.owtId || 'Not Generated'}
            </p>
          )}
          <p style={{ position: 'absolute', top: '10.2in', left: '0.3in' }}>
            {language === "English" ? "Date :" : "दि :"} {formatDate(formData.printdate)}
          </p>
          <p style={{ position: 'absolute', top: '10.2in', right: '0.6in' }}>
            {isPrincipal && isDean && isHeadmaster
              ? language === "English"
                ? "Principal / Dean / Headmaster"
                : "प्राचार्य / डीन / मुख्याध्यापक"
              : isPrincipal && isDean
                ? language === "English"
                  ? "Principal / Dean"
                  : "प्राचार्य / डीन"
                : isPrincipal && isHeadmaster
                  ? language === "English"
                    ? "Principal / Headmaster"
                    : "प्राचार्य / मुख्याध्यापक"
                  : isDean && isHeadmaster
                    ? language === "English"
                      ? "Dean / Headmaster"
                      : "डीन / मुख्याध्यापक"
                    : isPrincipal
                      ? language === "English"
                        ? "Principal"
                        : "प्राचार्य"
                      : isDean
                        ? language === "English"
                          ? "Dean"
                          : "डीन"
                        : isHeadmaster
                          ? language === "English"
                            ? "Headmaster"
                            : "मुख्याध्यापक"
                          : language === "English"
                            ? "Principal / Dean / Headmaster"
                            : "प्राचार्य / डीन / मुख्याध्यापक"}
          </p>

          <p style={{ position: 'absolute', top: '10.2in', right: '3.6in' }}>
            {language === "English"
              ? "Clerk"
              : "लिपिक"}
          </p>
        </div>

        <div style={{ height: '200px' }}>
        </div>
      </>
    );
  };



  const themes = [renderContent, renderContent2, renderContent3, renderContent4, renderContent5]; // Array of theme render functions
  // const themes = [renderContent, renderContent3]; // Array of theme render functions

  useEffect(() => {
    const savedThemeIndex = localStorage.getItem('defaultThemeIndex');
    const savedIsDefault = localStorage.getItem('isDefaultTheme') === 'true';

    if (savedThemeIndex) {
      setCurrentThemeIndex(Number(savedThemeIndex));
    }
    setIsDefaultTheme(savedIsDefault);
  }, []);

  const handleDefaultThemeChange = (event) => {
    const checked = event.target.checked;
    setIsDefaultTheme(checked);
    localStorage.setItem('isDefaultTheme', checked);
    if (checked) {
      localStorage.setItem('defaultThemeIndex', currentThemeIndex);
    } else {
      localStorage.removeItem('defaultThemeIndex');
    }
  };


  const convertDateFormat = (dateString) => {
    if (dateString) {
      const [year, month, day] = dateString.split('-'); // Split the date string
      return `${day}-${month}-${year}`; // Rearrange to dd-mm-yyyy format
    }
  };

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);
  useEffect(() => {

    if (udiseNumber) {
      fetchSchoolData(udiseNumber);
    }
  }, []);


  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    handleResize(); // Check initial screen size
    window.addEventListener('resize', handleResize); // Add event listener for window resize
    return () => window.removeEventListener('resize', handleResize); // Clean up event listener
  }, []);

  const openDatabase = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        // Define your object stores here if needed
        db.createObjectStore('studentData', { keyPath: 'id' });
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onerror = (event) => {
        reject('Error opening database: ' + event.target.errorCode);
      };
    });
  };

  const fetchSchoolData = async (udiseNumber) => {
    try {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onsuccess = async (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo); // Set the logo URL
            setLogoURL2(data.schoolLogo2); // Set the logo URL
          }
          setLoading(false);
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
          setLoading(false);
        };
      };

      request.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error fetching school data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const adjustBirthPlaceText = () => {
      const el = birthPlaceRef.current;
      if (!el) return;

      let fontSize = 16; // Start with a base font size
      el.style.fontSize = `${fontSize}px`;

      const getLineCount = () => {
        const computedStyle = window.getComputedStyle(el);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const height = el.offsetHeight;
        return {
          lines: Math.round(height / lineHeight),
          lineHeight,
        };
      };

      let { lines } = getLineCount();

      // Reduce font size if more than 1 line
      while (lines > 1 && fontSize > 12) {
        fontSize -= 2;
        el.style.fontSize = `${fontSize}px`;
        ({ lines } = getLineCount()); // Recalculate lines
      }

      // Set the top position based on the final line count
      if (lines === 1) {
        setBirthPlaceTop('6.2in'); // Single line — normal position
      } else {
        setBirthPlaceTop('6.12in'); // Multiple lines — move up slightly
      }
    };

    // Run after DOM update
    const timeoutId = setTimeout(adjustBirthPlaceText, 0);
    return () => clearTimeout(timeoutId); // Cleanup timeout
  }, [formData.birthPlace, currentThemeIndex]); // Dependency array to run effect when birthPlace changes

  useEffect(() => {
    const adjustSinceWhenText = () => {
      const el = sinceWhenRef.current;
      if (!el) return;

      let fontSize = 16;
      el.style.fontSize = `${fontSize}px`;

      const getLineCount = () => {
        const computedStyle = window.getComputedStyle(el);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const height = el.offsetHeight;
        return {
          lines: Math.round(height / lineHeight),
          lineHeight,
        };
      };

      let { lines } = getLineCount();
      let fontReduced = false;

      // Reduce font size if more than 1 line
      while (lines > 1 && fontSize > 12) {
        fontSize -= 2;
        el.style.fontSize = `${fontSize}px`;
        fontReduced = true;
        ({ lines } = getLineCount()); // Recalculate lines
      }

      // Check final line count after any reduction
      const finalLines = getLineCount().lines;


      // Top logic based on final line count
      if (finalLines === 1) {
        setsinceWhenTop('8.3in'); // Single line — normal position
      } else {
        setsinceWhenTop('8.19in'); // Multiple lines — move up slightly
      }
    };

    // Run after DOM update
    setTimeout(adjustSinceWhenText, 0);
  }, [formData.class, formData.sinceWhen, currentThemeIndex]); // Add dependencies


  // Inside your component before the return statement
  const checkForDuplicates = async (serialNo) => {
    const udiseNumber = localStorage.getItem("udiseNumber");
    const baseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}`;
    const existingSerialNoUrl = `${baseUrl}/leavedStd/${serialNo}.json`;

    try {
      const response = await fetch(existingSerialNoUrl);
      if (!response.ok) {
        setDuplicate(false);
        return;
      }

      const serialNoData = await response.json();
      if (!serialNoData) {
        setDuplicate(false);
        return;
      }

      // Check if there are multiple dates OR any date has multiple certificates
      const multipleEntries = Object.keys(serialNoData).length > 1 ||
        Object.values(serialNoData).some(value => Array.isArray(value));

      setDuplicate(multipleEntries);
    } catch (error) {
      console.error('Error checking for duplicates:', error);
      setDuplicate(false);
    }
  };

  useEffect(() => {
    if (formData.serialNo) {
      checkForDuplicates(formData.serialNo);
    } else {
      setDuplicate(false);
    }
  }, [formData.serialNo]);


  const getNextDocumentNumber = async (serialNo) => {
    const udiseNumber = localStorage.getItem("udiseNumber");
    const baseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}`;
    const lastDocUrl = `${baseUrl}/lastLeavDocumentNo.json`;

    try {
      const response = await fetch(lastDocUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch current document number');
      }

      const currentNumber = await response.json() || 0;
      const nextNumber = currentNumber + 1;

      await fetch(lastDocUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(nextNumber),
      });

      const year = new Date().getFullYear();
      const formattedNumber = `LC/${year}/${String(nextNumber).padStart(5, '0')}`;

      const formattedDate = moment(formData.date).format('DD-MM-YYYY');

      const existingSerialNoUrl = `${baseUrl}/leavedStd/${formData.serialNo}.json`;
      const existingSerialNoResponse = await fetch(existingSerialNoUrl);

      if (existingSerialNoResponse.ok) {
        const existingSerialNoData = await existingSerialNoResponse.json();

        if (existingSerialNoData && existingSerialNoData[formattedDate]) {
          let dateEntries;

          if (Array.isArray(existingSerialNoData[formattedDate])) {
            dateEntries = [...existingSerialNoData[formattedDate], formattedNumber];
          } else {
            dateEntries = [existingSerialNoData[formattedDate], formattedNumber];
          }

          const newDate = {};
          newDate[formattedDate] = dateEntries;

          await fetch(existingSerialNoUrl, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(newDate),
          });
        } else {
          const newDate = {};
          newDate[formattedDate] = formattedNumber;

          await fetch(existingSerialNoUrl, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(newDate),
          });
        }
        const updatedSerialNoResponse = await fetch(existingSerialNoUrl);
        if (updatedSerialNoResponse.ok) {
          const updatedData = await updatedSerialNoResponse.json();
          const hasDuplicates = Object.keys(updatedData).length > 1 ||
            Object.values(updatedData).some(value => Array.isArray(value));
          setDuplicate(hasDuplicates);
        }
      } else {
        setDuplicate(false);

        const newSerialNo = {};
        newSerialNo[formattedDate] = formattedNumber;

        await fetch(existingSerialNoUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(newSerialNo),
        });
      }

      return formattedNumber;
    } catch (error) {
      console.error('Error managing document number:', error);
      return null;
    }
  };



  const printCertificate = async () => {
    if (!isStudentActive) {
      setAlertMessage('Cannot print certificate for inactive students.');
      return;
    }

    if (!formData.registerno || !formData.stdName) {
      setAlertMessage('Please select Student Register No and Student Name before printing');
      return;
    }

    try {
      const newDocNumber = await getNextDocumentNumber();
      if (!newDocNumber) {
        setAlertMessage('Error generating document number');
        return;
      }

      setDocumentNumber(newDocNumber);

      const selectedStudentId = `${formData.class || ''}-${formData.division || ''}-${formData.serialNo || ''}`;

      const db = await openDatabase();
      const transaction = db.transaction(['studentData'], 'readwrite');
      const objectStore = transaction.objectStore('studentData');

      const studentRequest = objectStore.get(selectedStudentId);
      studentRequest.onsuccess = (event) => {
        const student = event.target.result;
        if (student) {
          student.isActive = false; // Set isActive to false
          const updateRequest = objectStore.put(student); // Update the student in IndexedDB

          updateRequest.onsuccess = () => {
            console.log(`Updated isActive to false for student ID: ${selectedStudentId}`);
          };

          updateRequest.onerror = (error) => {
            console.error('Error updating student in IndexedDB:', error);
          };

        } else {
          console.error(`Student with ID ${selectedStudentId} not found in IndexedDB.`);
        }
      };




      const updates = {};
      updates[`/schoolRegister/${udiseNumber}/studentData/${formData.serialNo}/isActive`] = false;

      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/.json`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to update Firebase');
      }

      await new Promise(resolve => setTimeout(resolve, 100));



      const outwardIdBaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/outwardIds`;
      const outwardIdResponse = await fetch(outwardIdBaseUrl + '.json');
      const outwardIdData = await outwardIdResponse.json() || {};

      const currentOutwardId = outwardIdData.current || 0;
      const nextOutwardId = currentOutwardId + 1;
      // Prepare the data to store
      const outwardIdEntry = {
        serialNo: formData.serialNo,
        reason: formData.reason,
        documentNumber: newDocNumber,
        date: formatDate(formData.printdate),
      };
      // Store the new outward ID and its details
      await fetch(outwardIdBaseUrl + `/${nextOutwardId}.json`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(outwardIdEntry),
      });
      // Update the current outward ID in the database
      await fetch(outwardIdBaseUrl + '/current.json', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(nextOutwardId),
      });




      const printContent = document.getElementById("print-content");
      if (!printContent) {
        setAlertMessage("Print content not found.");
        return;
      }

      const clone = printContent.cloneNode(true);
      clone.style.padding = "50px 381px";
      clone.style.transform = "translate(0, -70px) scale(1.08)";

      clone.querySelectorAll('p').forEach(p => {
        p.style.margin = "0";
        p.style.padding = "0";
        p.style.lineHeight = "1.4";
      });

      const printContainer = document.createElement("div");
      printContainer.appendChild(clone);

      printJS({
        printable: printContainer.innerHTML,
        type: 'raw-html',
        style: `
        @media print {
          body { margin: 0; }
          p { margin: 0; padding: 0; line-height: 1.4; }
          @page {
            size: A4 Portrait;
            margin: 8mm 8mm 8mm 9mm; /* this affects the margin in the printer settings */
          }
        }
      `
      });

    } catch (error) {
      console.error('Error in printCertificate:', error);
      setAlertMessage('Error printing certificate');
    }
  };
  const [showDuplicateText, setShowDuplicateText] = useState(true);

  const showduplicatecheckbox = (event) => {
    setShowDuplicateText(event.target.checked);
  }

  return (
    <>
      <AlertMessage message={alertMessage} show={showAlert} />
      <div>
        {duplicate && <>
          <div style={{ width: '210px', display: 'flex', marginLeft: '17px', marginBottom: '-30px', marginTop: '10px' }}>
            <label style={{ width: '230px', color: '#c31f1f' }}>{language === 'English' ? 'show duplicate' : 'दुबारप्रत दाखवा'}
            </label>
            <input className="input-field"
              type="checkbox"
              checked={showDuplicateText}
              onChange={showduplicatecheckbox}
              style={{ width: '20px', height: '20px', accentColor: '#c31f1f' }} />
          </div>
        </>}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '480px', marginTop: '30px' }}>
          <button
            onClick={printCertificate}
            style={{
              position: "relative",
              top: 0,
              left: '10px',
              cursor: isStudentActive ? "pointer" : "not-allowed",
              opacity: isStudentActive ? 1 : 0.5,
            }}
            disabled={!isStudentActive}
          >
            {duplicate ? "Print Duplicate" : "Print"}
          </button>

          <div style={{ marginTop: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {themes.map((_, index) => (
                <button
                  key={index}
                  className="theme-button"
                  onClick={() => {
                    setCurrentThemeIndex(index);
                    setIsDefaultTheme(false);
                  }}
                  style={{
                    backgroundColor: currentThemeIndex === index ? '#1B4332' : '#cccccc',
                    color: currentThemeIndex === index ? 'white' : 'black',
                  }}
                >
                  {index + 1}
                </button>
              ))}
            </div>

            <label style={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '10px' }}>
              <span style={{ width: '9%' }}>
                <input
                  type="checkbox"
                  checked={isDefaultTheme}
                  onChange={handleDefaultThemeChange}
                  style={{ width: '100%' }}
                />
              </span>
              <span style={{ width: '91%', color: 'gray' }}>
                Set as default theme
              </span>
            </label>
          </div>

          <style jsx>{`
  .theme-button {
    padding: 0px 7px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
  }

  .theme-button:hover {
    opacity: 0.9;
  }
`}</style>

        </div>

        <div id="print-content" style={{ marginBottom: '280px' }}>
          {loading ? <p>Loading...</p> : themes[currentThemeIndex]()}
        </div>

      </div>
    </>
  );
}

export default Leavdoc;   